import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Buttons from 'theme/components/Buttons.style';

export const Root = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const PortalAnchor = styled.div<{
  $mainShift?: number;
  $submenuShift?: number;
}>`
  position: fixed;
  width: 0;
  height: 0;
  --popover-main-shift: ${({ $mainShift }) => `${$mainShift ?? 0}px`};
  --popover-submenu-shift: ${({ $submenuShift }) => `${$submenuShift ?? 0}px`};
`;

export const TriggerPill = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 5px;
  background-color: ${colours.neutral[200]};
  border-radius: 300px;
`;

export const PopoverCard = styled.div<{
  $zIndex?: number;
  $topOffset?: number;
  $leftOffset?: number;
}>`
  position: absolute;
  top: 0;
  left: ${({ $leftOffset }) => `${$leftOffset ?? 0}px`};
  transform: translateY(
    ${({ $topOffset }) =>
      $topOffset && $topOffset > 0
        ? `calc(10px + ${$topOffset}px - var(--popover-submenu-shift, 0px))`
        : `calc(10px - var(--popover-main-shift, 0px))`}
  );
  width: 280px;
  background-color: white;
  border: 2px solid ${colours.neutral[200]};
  border-radius: 35px;
  box-shadow: 0px 50px 70px -35px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: ${({ $zIndex }) => $zIndex ?? 1300};
  display: flex;
  flex-direction: column;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 0;
  max-height: 420px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 30px;
  background-color: ${colours.neutral[200]};
  color: ${colours.neutral[900]};
  font-family: 'Inter Variable', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 650;
  line-height: 16px;
  flex-shrink: 0;
  box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05);
`;

export const PillWrapper = styled.span`
  display: inline-flex;
  flex: 1;
  min-width: 0;
`;

export const LeadingRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const MenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-right: 10px;
`;

export const HeaderResetButton = styled(Buttons.Ghost)`
  color: ${colours.neutral[600]};

  svg path {
    stroke: ${colours.neutral[600]};
  }

  @media (max-width: ${breakpoints.tablet}) {
    flex-grow: 0;
    width: fit-content;
  }
`;
